import React, { useState } from 'react';
import { NStatusTag, NTable } from '@innersource-nn/novoui-react';
import usePermissions, { DatasetPermissions } from '../hooks/usePemissions';
import Pagination from 'components/pager/Pagination';
import {
    DatasetSortField,
    SearchFilter,
    SortDirection,
    TableSortField,
} from 'types/Filters';
import { FormatDate } from 'components/dates/FormatDate';
import StatusInfoTab from 'components/tabs/StatusInfoTab';
import TableActionButton from 'components/buttons/TableActionButton';
import { getTagColor } from 'utils/getTagColorForShare';
import { TableSortStateType, TableSortState } from '@novonordisk/novoui-vuejs';

const PermissionList = () => {
    const [filter, setFilter] = useState<SearchFilter>({
        page: 1,
        pageSize: 10,
        term: '',
        sort: [
            {
                field: 'created' as TableSortField,
                direction: 'asc' as SortDirection,
            },
        ],
    });
    const tableHeaders = [
        { header: 'Requester', key: 'owner', isSortable: true },
        { header: 'Group', key: 'samlGroupName', isSortable: true },
        { header: 'Environment', key: 'environmentName', isSortable: true },
        { header: 'Stages', key: 'shareStageOptions' },
        {
            header: 'Created',
            key: 'created',
            isSortable: true,
            initialSortState: TableSortState.asc,
        },
        { header: 'Status', key: 'status' },
        { header: 'Approver', key: 'approver', isSortable: true },
        { header: '', key: 'action' },
    ];

    const { permissions, error, loading, items, showSearchbar } =
        usePermissions(filter);

    const sortItems = (newSortMap: Map<string, TableSortStateType>) => {
        for (const [key, value] of newSortMap) {
            const field = key as DatasetSortField;

            if (value === TableSortState.asc || value === TableSortState.desc) {
                setFilter({
                    ...filter,
                    sort: [{ field, direction: value }],
                });
                break; // NTable only allows to sort one field at the time
            }
        }
    };

    const adjustItems = (items: DatasetPermissions[]) => {
        return items.map((item) => {
            return {
                ...item,
                created: FormatDate(item.created),
                approver: item.approver.split('@')[0].toUpperCase(),
                owner: item.owner.split('@')[0].toUpperCase(),
                action: <TableActionButton path={`/share/${item.shareUri}`} />,
                status: (
                    <NStatusTag
                        label={item.status ?? 'No status'}
                        state={getTagColor(item.status)}
                    />
                ),
            };
        });
    };
    const showTable = !error && (loading || showSearchbar);

    return (
        <div>
            {showTable && (
                <div>
                    {/* TODO: add search bar when Backend adds filter */}
                    <NTable
                        loadXMoreRowsAtATime={loading ? 5 : undefined}
                        headers={tableHeaders}
                        columnBorder={true}
                        items={adjustItems(!loading ? permissions : [])}
                        rowKey="shareUri"
                        sorting={sortItems}
                        stickyHeader={false}
                    />
                    {!loading && items.count > 0 && (
                        <Pagination
                            items={items}
                            filter={filter}
                            setFilter={setFilter}
                        />
                    )}
                </div>
            )}
            {!showTable && (
                <StatusInfoTab
                    child="permissions"
                    parent="dataset"
                    error={error}
                />
            )}
        </div>
    );
};

export default PermissionList;
